import { Component, OnInit } from '@angular/core';
import { RemittancesService } from '../../../services/remittances.service'
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { SelectionDialog } from '../../utils/group-selection/selection.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { OrderEntryService } from 'src/app/services/service.index';
import { DeleteOrderDialog } from './modals/delete-order.component'
import { DeleteSampleDialog } from './modals/delete-sample.component';
import { CreateRemittanceDialog } from './modals/create-remittance.component';

import { PdfDialog } from '../../reports/modals/pdf.component';


@Component({
  selector: 'app-remittances',
  templateUrl: './remittances.component.html',
  styleUrls: ['./remittances.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class RemittancesComponent implements OnInit {

  user;
  group;
  wards;
  all = '';
  ward;
  filter: Filter;
  displayedColumns: string[] = ['select','orderDate', 'orderId', 'patientName', 'patientSex', 'wardDescription','actions'];
  newData;


  constructor( private service: RemittancesService,
    private adapter: DateAdapter<any>,
    private router: Router,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private matIconRegistry: MatIconRegistry,
    private orderEntryService: OrderEntryService,
    private route: ActivatedRoute) {
      this.adapter.setLocale('es');
      this.newData = false;

      this.filter = new Filter();
      this.user = this.userService.getUser();
      this.group = this.userService.getActiveGroup('order-entry');

      this.matIconRegistry.addSvgIcon("logo",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/tube.svg"));
       this.matIconRegistry.addSvgIcon("doctor",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/doctor.svg"));
      this.matIconRegistry.addSvgIcon("note",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/note.svg"));
      this.matIconRegistry.addSvgIcon("remitted",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/remitted.svg"));
      this.matIconRegistry.addSvgIcon("notRemitted",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/notRemitted.svg"));
      this.matIconRegistry.addSvgIcon("newRemittance",
      this.sanitizer.bypassSecurityTrustResourceUrl("./assets/newRemittance.svg"));


      if( this.group == null) {
        this.dialog.open(SelectionDialog, {
          data: {groupType: 'order-entry'},
          width: '40%',
          disableClose: true 
        });      
        
      } else{
        this.updateData();
      }

      this.userService.updateUser().subscribe(
        (newUser) => {
          this.user = newUser
          this.group = this.userService.getActiveGroup('order-entry');
          this.updateData();

        }
      )

      

    }

  ngOnInit(): void {
    this.route.paramMap.subscribe(
      params => {
        const search = params.get('search');
        
        if(search){
          this.filter = new Filter(JSON.parse(sessionStorage.getItem('filter')));
          this.updateData();

          if(this.filter){
            this.getRemittances();
            sessionStorage.clear();
          } else {
            this.filter = new Filter();
          }
        }


      }
    )
  }

  updateData() {
    this.wards = this.group.wards.sort((a, b) => (a.wardDescription > b.wardDescription) ? 1 : ((b.wardDescription > a.wardDescription) ? -1 : 0));
    this.filter.groupId = this.group.id;
  }

  remittances = new Array();

  getRemittances(){
    this.selectedRow = -1;
    this.selection.clear();
    this.service.getRemittances(this.filter).subscribe(
      data => {
        console.log(data)
        this.remittances = data.map( elem => ({...elem, show: false}))
        this.remittances.forEach(
          remit => {
            remit.tests = new Array();
            let profile = "";

            remit.samples.forEach(
              sample => {
                sample.tests.forEach( test =>
                  {
                    if(!test.profileId){
                      remit.tests.push(test)
                    } else{
                      
                      if(remit.tests.filter(profile => test.profileId == profile.id).length == 0){
                        remit.tests.push({id: test.profileId, description: test.profileDescription, type: 'P'})
                        profile = test.profileId;
                      }
                    }
                  })
                //sample.tests = sample.tests.map(test=>test.description).join(', ');
              }
            )

            const samples = remit.samples;
            //remit.samples = new Array();
            //for(let i = 0; i < samples.length; i+=4){
            //  remit.samples.push(samples.slice(i, i+4))
            //} 
          }
        )

        if(this.remittances.length>0)
          this.newData = true;


      }
    )
  }


  isExpansionDetailRow
  
  showOrder(order){
    const i = this.remittances.indexOf(order);
    this.remittances[i].show = !this.remittances[i].show;
  }

  // CHECKBOXES

  selection = new SelectionModel<any>(true, []);


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.remittances.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.remittances.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  selectOrder(order){
    sessionStorage.setItem(order.orderId, JSON.stringify(order))
    sessionStorage.setItem('filter', JSON.stringify(this.filter))
    this.router.navigate(['/order-entry/edit-order', {id: order.orderId}])
  }
  
  pageIndex = 0;
  pageSize = 10;
  get orders (){
    return this.remittances.slice(this.pageIndex*this.pageSize, this.pageIndex*this.pageSize+this.pageSize)
  }

  selectedRow = -1;
  opened(index){
    this.selectedRow = index;
  }

  unselectRow(){
    this.selectedRow = -1;
  }
  
  deleteOrder(order){
    const ref = this.dialog.open(DeleteOrderDialog, {
      data: order
    });

    ref.afterClosed().subscribe(
      (reload) => {
        console.log(reload)
        if(reload){
          this.getRemittances();
        }
      }
    )

  }

  deleteOrders(){
    const ref = this.dialog.open(DeleteOrderDialog, {
      data: this.selection.selected
    });

    ref.afterClosed().subscribe(
      (reload) => {
        console.log(reload)
        if(reload){
          this.getRemittances();
        }
      }
    )

  }

  deleteSample(order, sample){
    /*let hasProfile = false;
    sample.tests.forEach(element => {
      if(element.profileId != null) hasProfile = true; 
    });

    if(!hasProfile){
      order.tests = sample.tests
    } */

     const ref = this.dialog.open(DeleteSampleDialog, {
      data: {order, sample}
    });

    ref.afterClosed().subscribe(
      (reload) => {
        console.log(reload)
        if(reload){
          this.getRemittances();
        }
      }
    )
  }

  createRemittance(){

    if(this.canInsertRemittance()){
      this.dialog.open(CreateRemittanceDialog, {
        data: this.selection.selected
      }).afterClosed().subscribe(
        resp =>{
          if(resp){
            this.generateRemittance(this.selection.selected);
          }else if(resp!=null){
            this.generateRemittance(this.selection.selected.filter(order => order.remittanceId == 0));
          }
        }
      )
    } else{
      this.generateRemittance(this.selection.selected);
    }

    
  }

  generateRemittance(selection){
    let wardSet =  new Set(selection.map(order => order.wardId));
    let wards = Array.from(wardSet);

    wards = wards.map(ward => ({wardId: ward}));
    wards.forEach( ward => { ward['order'] = selection.filter(order => order.wardId == ward['wardId']) } )
    wards = wards.map(function(ward: any) {return ({...ward, wardDescription: ward.order[0].wardDescription})});


    let data = JSON.stringify({orders: wards, group_id: this.user['order-entry'], group_type: 'order_entry', type: 'remittance'})
    this.service.createRemittance(data).subscribe(
      data => {
        let pdf = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data));
        this.dialog.open(PdfDialog, {
          width: '80%',
          height: '89%',
          data: pdf
        }).afterClosed().subscribe(
          () => this.getRemittances()
        );
      }
    )

    this.service.insertRemittance(selection).subscribe(
      data => console.log(data)
    )

    this.selection.clear();
  }

  insertRemittance(){
    this.service.insertRemittance(this.selection.selected).subscribe(
      data => console.log(data)
    )

    this.selection.clear();
  }

  deleteRemittance(){
    this.service.deleteOrderFromRemittance(this.selection.selected).subscribe(
      data => {this.getRemittances(); this.selection.clear()}
    )
  }

  deleteOrderFromRemittance(order){
    this.service.deleteOrderFromRemittance([order]).subscribe(
      data =>  {this.getRemittances(); this.selection.clear()}
    )
  }
  insertOrderInRemittance(order){
    order = [order]
    this.service.insertRemittance(order).subscribe(
      data =>  {this.getRemittances(); this.selection.clear()}
    )
  }

  canInsertRemittance(){
    return this.selection.selected.filter( order=> order.remittanceId != 0).length > 0
  }

  canDeleteRemittance(){
    return this.selection.selected.filter( order=> order.remittanceId == 0).length > 0
  }

}

export class Filter {
  constructor( filter? ){
    this.user = true;
    this.startDate = new Date();
    this.endDate = new Date();
    this.ward = '';
    this.withRemittance = true;
    this.withoutRemittance = true;
    this.allComplete = true;

    if(filter){
      this.user = filter.user;
      this.groupId = filter.groupId;
      this.startDate = new Date(filter.startDate);
      this.endDate = new Date(filter.endDate);
      this.ward = filter.ward;
    }

  }

  public clear(){
    this.user = true;
    this.startDate = new Date();
    this.endDate = new Date();
    this.ward = '';
    this.withRemittance = true;
    this.withoutRemittance = true;
    this.allComplete = true;

  }

  updateAllComplete() {
    this.allComplete = this.withRemittance && this.withoutRemittance;
  }

  someComplete(): boolean {
    if (!this.withRemittance && !this.withoutRemittance) {
      return false;
    }
    return (this.withRemittance || this.withoutRemittance) && (this.withRemittance != this.withoutRemittance);
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    this.withRemittance = completed;
    this.withoutRemittance = completed;
  }


 

  user: boolean;
  groupId;
  ward;
  startDate;
  endDate;
  withRemittance;
  withoutRemittance;
  allComplete;
}
